import React, { memo, Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import { Accordion } from "react-bootstrap";

/* ──  react-icons  ───────────────────────────── */
import { AiOutlineHome } from "react-icons/ai"; // Overview
import {
  FaUserTie,
  FaUsers,
  FaMoneyCheckAlt,
  FaStar,
  FaUserCheck,
} from "react-icons/fa"; // Vendors / Customers / Payments / Reviews
import {
  MdAgriculture,
  MdWorkOutline,
  MdOutlineEmojiEvents,
  MdPayment,
  MdLiveHelp,
  MdSettings,
  MdLabel,
} from "react-icons/md"; // Equip / Jobs / Settings
import { FaLeaf } from "react-icons/fa"; // Crop icon
/* ─────────────────────────────────────────────── */

const VerticalNav = memo(() => {
  const location = useLocation();
  const isActive = (path) => (location.pathname === path ? "active" : "");

  const menu = [
    {
      path: "/dashboard",
      label: "Overview",
      icon: <AiOutlineHome size={20} />,
    },
    {
      path: "/dashboard/app/vendor-listing",
      label: "Vendors",
      icon: <FaUserTie size={20} />,
    },
    {
      path: "/dashboard/app/customer-listing",
      label: "Customers",
      icon: <FaUsers size={20} />,
    },
    {
      path: "/dashboard/app/kyc",
      label: "KYC",
      icon: <FaUserCheck size={20} />,
    },
    {
      path: "/equipments",
      label: "Equipments",
      icon: <MdAgriculture size={20} />,
    },
    { path: "/dashboard/crop", label: "Crop", icon: <FaLeaf size={20} /> },
    { path: "/jobs", label: "Jobs", icon: <MdWorkOutline size={20} /> },
    // {
    //   path: "/refferals",
    //   label: "Refferal",
    //   icon: <MdOutlineEmojiEvents size={20} />,
    // },
    {
      path: "/payment-settlement",
      label: "Payment Settlement",
      icon: <MdPayment size={20} />,
    },
    { path: "/faq", label: "Faq", icon: <MdLiveHelp size={20} /> },
    {
      path: "/label",
      label: "label",
      icon: <MdLabel size={20} />,
    },
    {
      path: "/refferals-manage",
      label: "Refferal Manage",
      icon: <MdOutlineEmojiEvents size={20} />,
    },
    // { path: '/payments',    label: 'Payments',         icon: <FaMoneyCheckAlt size={20}/> },
    // { path: '/reviews',     label: 'Reviews & Rating', icon: <FaStar          size={20}/> },
    // { path: '/settings',    label: 'Setting',          icon: <MdSettings      size={20}/> },
  ];

  return (
    <>
      <Accordion as="ul" className="navbar-nav iq-main-menu">
        {/* small “Menu” header */}

        {menu.map(({ path, label, icon }) => (
          <li key={path} className={`nav-item mb-3 ${isActive(path)}`}>
            <Link className={`nav-link ${isActive(path)}`} to={path}>
              {/*  ⬇︎ use <i className="icon"> so Hope-UI CSS keeps it visible in mini-mode  */}
              <i className="icon me-2 d-flex align-items-center">{icon}</i>
              <span className="item-name fs-6 fw-semibold">{label}</span>
            </Link>
          </li>
        ))}
      </Accordion>
    </>
  );
});

export default VerticalNav;
